export const errorRouteNames = {
  ERROR404: '404',
  LOAD_FAILED: 'load-failed',
};
